{
  "info": "Info",
  "negative": "Error",
  "positive": "Success"
}
